import { ArticleSearchParams } from '@obeta/models/lib/models/Search'
import { useArticlesSearchProvider } from '@obeta/data/lib/hooks/useArticleSearchProvider'

export const useAvailability = (props: { searchParams?: ArticleSearchParams }) => {
  const { availabilityResult, isFetching } = useArticlesSearchProvider()
  return {
    availability: availabilityResult,
    loading: isFetching,
  }
}
